import { ProjectId } from 'api/models';
import { ProjectDetailTabKeys } from 'api/project';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { getProjectConversationPageUrl, getProjectMeetingPagesUrl, getProjectNitroPagesUrl, getProjectSettingsUrl, getProjectSpacesUrl, getProjectStatusUpdatesUrl, getProjectTaskBoardUrl, getProjectTasksUrl } from 'utils/urls';
/** Project detail tabs shown in the Nitro Claw / Tauri shell (display order). */ export const NITRO_CLAW_PROJECT_TAB_ORDER = [
    ProjectDetailTabKeys.TaskList,
    ProjectDetailTabKeys.MeetingPages,
    ProjectDetailTabKeys.Spaces,
    ProjectDetailTabKeys.NitroPages,
    ProjectDetailTabKeys.Chat,
    ProjectDetailTabKeys.StatusUpdate
];
export const NITRO_CLAW_PROJECT_TAB_KEYS = new Set(NITRO_CLAW_PROJECT_TAB_ORDER);
/**
 * Base path prefixes for claw tabs — same URL helpers as
 * `useTabActions().getPathName`, using the tab root so nested routes
 * (`/spaces/1/tabs/2`, `/chat/9`) still match.
 *
 * TaskList: getPathName returns `/tasks/list`; we use `/tasks` so bare
 * `/tasks` is allowed, then exclude board below.
 */ const getNitroClawTabPathPrefix = (projectId, key)=>{
    switch(key){
        case ProjectDetailTabKeys.TaskList:
            return getProjectTasksUrl(projectId);
        case ProjectDetailTabKeys.MeetingPages:
            return getProjectMeetingPagesUrl(projectId);
        case ProjectDetailTabKeys.Spaces:
            return getProjectSpacesUrl(projectId);
        case ProjectDetailTabKeys.NitroPages:
            return getProjectNitroPagesUrl(projectId);
        case ProjectDetailTabKeys.Chat:
            return getProjectConversationPageUrl(projectId);
        case ProjectDetailTabKeys.StatusUpdate:
            return getProjectStatusUpdatesUrl(projectId);
    }
};
const pathMatchesPrefix = (pathname, prefix)=>pathname === prefix || pathname.startsWith(`${prefix}/`);
/**
 * Claw access for a URL:
 * - `null` — not `/projects/:id…` (ignore)
 * - `true` — bare project, an allowed tab, or settings
 * - `false` — disallowed tab (plan, overview, board, …)
 *
 * Example: `/projects/42/spaces/1/tabs/2` → matches Spaces prefix → allowed.
 */ export const isNitroClawProjectPathAllowed = (pathname)=>{
    var _parts_;
    const parts = pathname.split('/').filter(Boolean);
    if (parts[0] !== ROUTE_PATHS.PROJECTS || !/^\d+$/.test((_parts_ = parts[1]) !== null && _parts_ !== void 0 ? _parts_ : '')) {
        return null;
    }
    if (!parts[2]) {
        return true;
    }
    const projectId = ProjectId(Number(parts[1]));
    // Task board shares the TaskList `/tasks` prefix but is not a claw tab.
    if (pathMatchesPrefix(pathname, getProjectTaskBoardUrl(projectId))) {
        return false;
    }
    if (pathMatchesPrefix(pathname, getProjectSettingsUrl(projectId))) {
        return true;
    }
    return NITRO_CLAW_PROJECT_TAB_ORDER.some((key)=>pathMatchesPrefix(pathname, getNitroClawTabPathPrefix(projectId, key)));
};
